import { defineComponent as A, openBlock as o, createElementBlock as e, mergeProps as m, unref as a, renderSlot as p, createElementVNode as n, createCommentVNode as Z } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const H = { key: 0 }, g = { key: 1 }, M = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconDivide"
}, V = /* @__PURE__ */ A({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: l } = u(s);
    return (i, t) => (o(), e("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      p(i.$slots, "default"),
      a(l) === "bold" ? (o(), e("g", H, t[0] || (t[0] = [
        n("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM128,84a20,20,0,1,0-20-20A20,20,0,0,0,128,84Zm0,88a20,20,0,1,0,20,20A20,20,0,0,0,128,172Z" }, null, -1)
      ]))) : a(l) === "duotone" ? (o(), e("g", g, t[1] || (t[1] = [
        n("path", {
          d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM128,80a16,16,0,1,0-16-16A16,16,0,0,0,128,80Zm0,96a16,16,0,1,0,16,16A16,16,0,0,0,128,176Z" }, null, -1)
      ]))) : a(l) === "fill" ? (o(), e("g", M, t[2] || (t[2] = [
        n("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,64a16,16,0,1,1-16,16A16,16,0,0,1,128,64Zm0,128a16,16,0,1,1,16-16A16,16,0,0,1,128,192Zm56-56H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : a(l) === "light" ? (o(), e("g", f, t[3] || (t[3] = [
        n("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM128,78a14,14,0,1,0-14-14A14,14,0,0,0,128,78Zm0,100a14,14,0,1,0,14,14A14,14,0,0,0,128,178Z" }, null, -1)
      ]))) : a(l) === "regular" ? (o(), e("g", k, t[4] || (t[4] = [
        n("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM128,80a16,16,0,1,0-16-16A16,16,0,0,0,128,80Zm0,96a16,16,0,1,0,16,16A16,16,0,0,0,128,176Z" }, null, -1)
      ]))) : a(l) === "thin" ? (o(), e("g", h, t[5] || (t[5] = [
        n("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM128,76a12,12,0,1,0-12-12A12,12,0,0,0,128,76Zm0,104a12,12,0,1,0,12,12A12,12,0,0,0,128,180Z" }, null, -1)
      ]))) : Z("", !0)
    ], 16));
  }
});
export {
  V as default
};
